module.exports = __webpack_public_path__ + "img/verwirrt.90a7f0ba.svg";